import { NgModule, inject } from '@angular/core';
import {CommonModule} from '@angular/common';

import {throwIfAlreadyLoaded} from './guards/module-import-guard';
import {RouterModule} from '@angular/router';

@NgModule({
    imports: [CommonModule, RouterModule],
    declarations: [],
})
export class CoreModule {
    constructor() {
        const parentModule = inject(CoreModule, { optional: true, skipSelf: true });

        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}
